{
  "name": "admin-panel",
  "version": "1.9.0",
  "staticVersion": "1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "e2e": "ng e2e",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.12",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/forms": "^17.3.12",
    "@angular/material": "^17.3.10",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@angular/service-worker": "^17.3.12",
    "@ngrx/signals": "^17.2.0",
    "@orderna/pg-api-contracts": "^0.11.0",
    "@types/jsbarcode": "^3.11.4",
    "@types/qrcode": "^1.5.6",
    "angularx-flatpickr": "^7.3.0",
    "apexcharts": "^3.54.1",
    "autoprefixer": "^10.4.19",
    "dexie": "^4.2.1",
    "flatpickr": "^4.6.13",
    "hammerjs": "^2.0.8",
    "html5-qrcode": "^2.3.8",
    "jsbarcode": "^3.12.3",
    "jwt-decode": "^4.0.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.48",
    "ng-apexcharts": "1.10.0",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-webcam": "^0.4.1",
    "postcss": "^8.4.38",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.2",
    "socket.io-client": "^4.8.1",
    "tslib": "^2.8.1",
    "uuid": "^9.0.1",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.2",
    "@angular/cli": "^17.3.2",
    "@angular/compiler-cli": "^17.3.0",
    "@cypress/schematic": "^2.5.2",
    "@types/jasmine": "~5.1.0",
    "@types/uuid": "^9.0.8",
    "autoprefixer": "^10.4.19",
    "cypress": "^13.14.2",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.38",
    "tailwindcss": "^3.4.3",
    "typescript": "~5.4.2"
  }
}
